<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="12" v-if="flag === '1-B'">
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">裁判功能</span>
            </el-col>
          </el-row>
          <el-button type="primary" plain icon="el-icon-s-data" @click="showStuList">实时排名</el-button>
          <el-button type="primary" plain icon="el-icon-link" @click="copy">大屏排名链接</el-button>
          <el-button type="primary" plain icon="el-icon-download" @click="exportTable" >导出裁判系统</el-button>
        </el-card>
      </el-col>
      <el-col :span="flag === '1-B' ? 12 : 24">
        <!-- 筛选 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">{{flag === '3' ? '选择考场' : '筛选'}}</span>
            </el-col>
          </el-row>
          <el-form
            :model="queryForm"
            class="filter_Form"
            label-width="90px"
            ref="queryFormRef"
          >
            <el-row>
              <el-col :span="flag === '1-B' ? 12 : 6">
                <el-form-item label="赛季" prop="season" style="margin-bottom: 0;">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.season"
                    :disabled="flag === '3' ? true : false"
                    @change="changeFn"
                  >
                    <el-option
                      v-for="item in dict_season"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <template v-if="flag === '1-B'">
                  <el-col :span="12">
                  <el-form-item label="组别" prop="level" style="margin-bottom: 0;">
                    <el-select
                      placeholder="请选择类型"
                      style="width: 100%"
                      v-model="level"
                      @change="get1BDataList"
                    >
                      <el-option
                        v-for="item in dict_group"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictCode"
                      ></el-option>
                    </el-select> </el-form-item
                ></el-col>
              </template>
              <template v-if="flag === '3'">
                <el-col :span="6">
                  <el-form-item label="赛区" prop="districtId">
                    <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="queryForm.districtId"
                      @change="changeFn"
                    >
                      <el-option
                        v-for="item in dict_district"
                        :key="item.id"
                        :label="item.districtName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="赛程" prop="raceSchedule">
                    <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="queryForm.raceSchedule"
                      :disabled="flag === '3' ? true : false"
                      @change="changeFn"
                    >
                      <el-option
                        v-for="item in dict_matchType"
                        :key="item.id"
                        :label="item.scheduleName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="考场名称" prop="examRoomId" >
                    <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="examRoomId"
                      filterable
                      @change="examRoomChange"
                    >
                      <el-option
                        v-for="(item,index) in examRooms"
                        :key="index"
                        :label="item.roomName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="24" style="text-align: right;" v-if="examRoomId">
                  <el-button type="primary" @click="getList">查 询</el-button>
                </el-col> -->
              </template>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <template v-if="examRoomId || level">
        <el-row class="title_row">
          <el-col :span="12">
            <span class="title_class">
              比赛信息<i class="refresh" :class="isLoading ? 'el-icon-loading' : 'el-icon-refresh'" @click="searchFn"></i>
            </span>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-button type="danger" @click="handleToEnd" v-if="total > 0">本场比赛结束</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="50" class="info" v-if="flag === '3'">
          <el-col :span="6"><span class="info-t">考场名称</span>{{examRoomInfo.roomName}}</el-col>
          <el-col :span="6"><span class="info-t">组别</span>{{levelFormat(examRoomInfo.roomLevel)}}</el-col>
          <el-col :span="6"><span class="info-t">考位数量</span><b class="score">{{total}}</b>/{{ examRoomInfo.roomNum }}</el-col>
          <el-col :span="6"><span class="info-t">{{ examRoomInfo.roomType === 1 ? '会议号' : '考场地址' }}</span>{{examRoomInfo.roomAddress}}</el-col>
          <el-col :span="12"><span class="info-t">比赛时间</span>{{examRoomInfo.roomStartTime}} ～ {{examRoomInfo.roomEndTime}}</el-col>
        </el-row>
        <el-table
          header-cell-class-name="tableHeaderStyle"
          :data="dataList"
          border
          stripe
        >
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="姓名" prop="examinationUserName"></el-table-column>
          <el-table-column label="手机号" prop="examinationUserPhone"></el-table-column>
          <el-table-column label="准考证号" prop="examinationNumber" v-if="flag === '3'"></el-table-column>
          <el-table-column label="学校" prop="examinationUserSchoolName"></el-table-column>
          <el-table-column label="年级" prop="examinationUserGrade" :formatter="gradeFormat"></el-table-column>
          <el-table-column label="比赛号码牌" prop="matchNum">
            <template slot-scope="scope">
              <span class="num num1">{{ addZero(scope.row.matchNum) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="抽签顺序号" prop="raceNumber">
            <template slot-scope="scope">
              <span class="num">{{ addZero(scope.row.raceNumber) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="A轮得分" align="center" prop="roundOne" v-if="flag === '1-B'">
            <template slot-scope="{ row }">
              <div class="score">{{scoreFormat(row.roundOne)}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="flag === '1-B' ? 'Word1' : 'Round2'" width="140px" align="center">
            <template slot-scope="{ row }">
              <div class="radio-group">
                <div class="radio-correct" :class="row.correctTwo === 1 ? 'active' : ''" @click="round2Change(row, 1)">正确</div>
                <div class="radio-wrong" :class="row.correctTwo === 0 ? 'active' : ''" @click="round2Change(row, 0)">错误</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="flag === '1-B' ? 'Word1 得分' : 'Round2 得分'" align="center" prop="roundTwo">
            <template slot-scope="{ row }">
              <div class="score">{{scoreFormat(row.roundTwo)}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="flag === '1-B' ? 'Word2' : 'Round3'" width="140px" align="center">
            <template slot-scope="{ row }">
              <div class="radio-group">
                <div class="radio-correct" :class="row.correctThree === 1 ? 'active' : ''" @click="round3Change(row, 1)">正确</div>
                <div class="radio-wrong" :class="row.correctThree === 0 ? 'active' : ''" @click="round3Change(row, 0)">错误</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="flag === '1-B' ? 'Word2 得分' : 'Round3 得分'" align="center" prop="roundThree">
            <template slot-scope="{ row }">
              <div class="score">{{scoreFormat(row.roundThree)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="晋级状态" v-if="flag === '1-B'" prop="groupTwoPromote" width="100px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.groupTwoPromote" @change="promoteChange(scope.row)" size="small" :class="'promote' + scope.row.groupTwoPromote">
                <el-option
                  v-for="item in pList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="flag === '3'">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-delete" size="small" @click="delFn(scope.row)">移出考场</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination v-if="group === 3"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[20, 30, 40, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <div style="text-align: center;margin-top: 40px;">
          <el-button type="danger" style="width: 140px;" @click="handleToEnd" v-if="total > 0">本场比赛结束</el-button>
        </div>
      </template>
      <div class="default" v-else>
        <!-- <div>请选择考场</div> -->
        <el-empty :description="'请选择' + (flag === '3' ? '考场' : '组别')"></el-empty>
      </div>
    </el-card>
    <el-dialog
      title="AB轮综合排名(晋级比例60%)"
      :visible.sync="showRank"
      :close-on-click-modal="false"
      width="60%">
      <div class="set-info">
        <span>设置晋级到C轮人数：</span>
        <el-input-number v-model="setNextNum" :min="1" :max="rankList.length"></el-input-number>
        <el-button type="primary" style="margin-left:20px;" @click="setNextNumFn">确认</el-button>
      </div>
      <el-table style="margin-top: 0;"
        header-cell-class-name="tableHeaderStyle"
        :data="rankList"
        :row-class-name="tableRowClassName"
        border
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="姓名" prop="userName">
          <template slot-scope="scope">
            <span class="num num1">{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="比赛号码牌" prop="matchNum">
          <template slot-scope="scope">
            <span class="num num1">{{ addZero(scope.row.matchNum) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="抽签号码" prop="raceNumber">
          <template slot-scope="scope">
            <span class="num">{{ addZero(scope.row.raceNumber) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="排名" prop="rankTwo"></el-table-column> -->
        <el-table-column label="分数" prop="roundTotal">
          <template slot-scope="scope">
            <div class="rank-score">{{ scope.row.roundTotal }}</div>
          </template>
        </el-table-column>
        <el-table-column label="学校" prop="schoolName"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column
          label="组别"
          prop="enrollmentLevel"
          :formatter="levelFormatter"
        ></el-table-column>
        <el-table-column
          label="年级"
          prop="grade"
          :formatter="gradeFormatter"
        ></el-table-column>
      </el-table>
    </el-dialog>

    <!-- 登录情况 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%">
      <span slot="title">
        {{ dialogTitle }}
        <i class="refresh" :class="loading ? 'el-icon-loading' : 'el-icon-refresh'" @click="showStuList(dialogType)"></i>
      </span>
      <!-- 实时排名 -->
      <el-tabs type="border-card" @tab-click="handleClick" v-model="queryStuForm.groupTwoPromote">
        <el-tab-pane label="晋级名单" name="1"></el-tab-pane>
        <el-tab-pane label="淘汰名单" name="0"></el-tab-pane>
        <el-tab-pane label="未设置" name="-1"></el-tab-pane>
      </el-tabs>
      <el-table style="margin-top: 0;" v-if="dialogVisible"
        header-cell-class-name="tableHeaderStyle"
        :data="stuList"
        border
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="姓名" prop="userName">
          <template slot-scope="scope">
            <span class="num num1">{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="比赛号码牌" prop="matchNum">
          <template slot-scope="scope">
            <span class="num num1">{{ addZero(scope.row.matchNum) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="抽签顺序号" prop="raceNumber">
          <template slot-scope="scope">
            <span class="num">{{ addZero(scope.row.raceNumber) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排名" prop="groupTwoRank">
          <template slot-scope="scope">
            <div class="rank-index">{{ scope.row.groupTwoRank }}</div>
          </template>
        </el-table-column>
        <el-table-column label="AB总分" prop="roundTotal"></el-table-column>
        <el-table-column label="A轮得分" prop="roundOne"></el-table-column>
        <el-table-column label="B-1得分" prop="roundTwo"></el-table-column>
        <el-table-column label="B-2得分" prop="roundThree"></el-table-column>
        <el-table-column label="晋级状态" prop="groupTwoPromote">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.groupTwoPromote === 1 ? 'success' : scope.row.groupTwoPromote === 0 ? 'danger' : ''">
              {{ scope.row.groupTwoPromote === 1 ? '晋级' : scope.row.groupTwoPromote === 0 ? '淘汰' : '未设置' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="学校" prop="schoolName"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column
          label="组别"
          prop="enrollmentLevel"
          :formatter="levelFormatter"
        ></el-table-column>
        <el-table-column
          label="年级"
          prop="grade"
          :formatter="gradeFormatter"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { queryDistrictPage, queryExaminationUserListPage, resetSingleUser } from '@/http/api'

export default {
  name: 'groupB',
  props: {
    flag: { // 1-B有组别  3-复选
      Type: String,
      default: 0
    }
  },
  data () {
    return {
      examRooms: [], // 考场下拉列表
      examRoomId: '', // 选中考场id
      examRoomInfo: {}, // 考场信息
      dict_district: [], // 赛区下拉列表
      dict_matchType: [], // 赛程下拉列表
      dict_group: this.$userInfo.dict_group(), // 组别下拉列表
      dict_grade: this.$userInfo.getGradeData(), // 年级
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }), // 赛季下拉列表
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        raceSchedule: ''
      },
      level: '',
      dataList: [],
      total: 0,
      loading: null,
      isLoading: false,
      pageNum: 1,
      pageSize: 30,
      rankList: [],
      showRank: false,
      setNextNum: '',
      queryStuForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: this.$chnEngStatusCode.raceScheduleFinal,
        isGroup: Number(this.$route.query.group),
        groupTwoPromote: '1' // 1:晋级 0:未晋级 -1:未设置
      },
      dialogTitle: '',
      detailVisible: false,
      dialogVisible: false,
      totalScore: 0,
      userName: '',
      matchNum: '',
      paperData: {},
      pList: [
        { label: '晋级', value: 1 },
        { label: '淘汰', value: 0 },
        { label: '未设置', value: -1 }
      ]
    }
  },
  created () {
    this.group = Number(this.$route.query.group)
  },
  methods: {
    init3 () {
      console.log('init3')
      this.level = ''
      const params = this.$route.query
      if (params.id && params.flag === '3') {
        this.loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.queryForm.season = '2022~2023'
        this.queryForm.districtId = params.d
        this.queryForm.raceSchedule = params.r
        this.examRoomId = params.id
      }
      // 赛程--默认传入复赛 2 写死的
      this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(value => {
        this.dict_matchType = value
        this.queryForm.season = '2022~2023'
        this.queryForm.raceSchedule = params.r || '2'
      })
      // 赛区--不传入默认取全国非
      this.getDistrictList(params.d)
    },
    init1B () {
      console.log('init1B')
      this.examRoomId = ''
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex < this.setNextNum) {
        return 'success-row'
      }
      return ''
    },
    searchFn () {
      this.isLoading = true
      if (this.flag === '1-B') {
        this.init1B()
        this.get1BDataList()
      } else if (this.flag === '3') {
        this.init3()
      }
    },
    showStuList (type, init = true) { // 1-登录情况 2-实时排名 3-设置晋级人数
      if (!this.level) {
        return this.$message.warning('请选择组别')
      }
      this.loading = true
      this.dialogTitle = '实时排名'
      this.queryStuForm.activityType = this.queryForm.activityType
      this.queryStuForm.season = this.queryForm.season
      this.$http.get('/national/queryNationalGroupList', { params: { ...this.queryStuForm, ...{ level: this.level, round: 2 } } }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.stuList = res.data
          this.dialogVisible = true
        }
      })
    },
    handleClick (e) {
      this.queryStuForm.groupTwoPromote = e.name
      this.showStuList(2, false)
    },
    promoteChange (item) {
      console.log(item)
      this.$http.post('national/updateGroupTwoPromote', {
        groupTwoPromote: item.groupTwoPromote,
        nationalId: item.nationalId
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
        }
      })
    },
    get1BDataList () {
      this.$http.get('/national/queryNationalGroupList', {
        params: {
          season: this.queryForm.season,
          level: this.level,
          round: 3,
          activityType: this.queryForm.activityType,
          isGroup: this.group
        }
      }).then(res => {
        this.isLoading = false
        if (res.code === 200) {
          res.data.forEach(item => {
            if (item.correctTwo === undefined || item.correctTwo === null) {
              item.correctTwo = -1
            }
            if (!item.correctThree === undefined || item.correctThree === null) {
              item.correctThree = -1
            }
          })
          this.dataList = res.data
          this.total = res.data.length
          this.dataList.forEach(item => {
            item.examinationUserName = item.userName
            item.examinationUserPhone = item.phone
            item.examinationUserSchoolName = item.schoolName
            item.examinationUserGrade = item.grade
          })
        }
      })
    },
    // 获取赛区筛选数据
    getDistrictList (districtId) {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        this.queryForm.districtId = districtId || this.dict_district[1].id
        this.getExamRoomSelect()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 获取考场列表
    getExamRoomSelect () {
      this.$http.get('examination/queryExaminationList', { params: this.queryForm }).then(res => {
        this.examRooms = res.data
        if (this.examRoomId) { // 路径带入，直接获取信息
          this.examRoomInfo = res.data.find(item => item.id === this.examRoomId)
          this.getList()
          this.loading.close()
        }
      })
    },
    // 获取考生列表
    getList () {
      if (this.flag === '3') {
        this.get3DataList()
      } else if (this.flag === '1-B') {
        this.get1BDataList()
      }
    },
    get3DataList () {
      queryExaminationUserListPage({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        examinationId: this.examRoomId
      }).then(res => {
        res.data.list.forEach(item => {
          if (item.correctTwo === undefined || item.correctTwo === null) {
            item.correctTwo = -1
          }
          if (!item.correctThree === undefined || item.correctThree === null) {
            item.correctThree = -1
          }
        })
        this.dataList = res.data.list
        this.total = res.data.total
      })
    },
    handleSizeChange (e) {
      this.pageSize = e
      this.getList()
    },

    handleCurrentChange (e) {
      this.pageNum = e
      this.getList()
    },

    changeFn () {
      this.examRoomId = ''
      this.getExamRoomSelect()
    },
    // 切换考场
    examRoomChange (e) {
      // 修改考场信息
      this.examRoomInfo = this.examRooms.find(item => item.id === this.examRoomId)
      // 获取考生列表
      this.getList()
    },

    delFn (row) {
      this.$confirm('确认将该选手移出考场？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetSingleUser(row.id).then(res => {
          this.$message.success('已移出')
          this.pageNum = 1
          this.getList()
        })
      }).catch(() => {
      })
    },

    gradeFormat (row) {
      const grade = row.examinationUserGrade || row.grade
      return grade ? this.dict_grade.find(item => item.dictCode === grade).dictLabel : '-'
    },
    levelFormat (level) {
      return level ? this.dict_group.find(item => Number(item.dictValue) === level).dictLabel : '--'
    },
    scoreFormat (score) {
      return score === undefined || score === null ? '--' : score
    },
    submitFn () {
      this.$http.post('/examinationUser/closeTestMatchExamination', {
        activityType: this.queryForm.activityType,
        id: this.examRoomId,
        raceSchedule: this.queryForm.raceSchedule,
        season: this.queryForm.season
      }).then(res => {
        if (res.code === 200) {
          this.$confirm('本场比赛结束，是否去查看成绩？', '提示', {
            confirmButtonText: '去看看',
            cancelButtonText: '留在本页',
            type: 'warning'
          }).then(() => {
            this.$router.push(
              {
                path: '/examination_Management/individual_examination_management/schedule_competitions/schedule_rematch_competition',
                query: {
                  scheduleFlag: 'INDIVIDUAL_FINAL',
                  l: this.examRoomInfo.roomLevel
                }
              }
            )
          }).catch(() => {
            // 取消
          })
        }
      })
    },

    round2Change (item, value) {
      item.correctTwo = value
      this.judgeFn(item)
    },
    round3Change (item, value) {
      item.correctThree = value
      this.judgeFn(item)
    },
    judgeFn ({ id, correctTwo, correctThree }) {
      const url = this.flag === '1-B' ? '/national/updateNationalGroupBScore' : '/examinationUser/updateExaminationRoomUser'
      this.$http.post(url, { id, correctTwo, correctThree }).then(res => {
        if (res.code === 200) {
          this.getList()
        }
      })
    },
    handleToEnd () {
      this.$confirm('确认结束本场比赛？比赛结束后，将生成此次比赛成绩。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.flag === '1-B') {
          this.get1BRank()
        } else {
          this.submitFn()
        }
      }).catch(() => {
        // 取消
      })
    },
    exportTable () {
      if (!this.level) {
        return this.$message.warning('请选择组别')
      }
      const downLoadUrl = `${this.$http.defaults.baseURL}national/excelNationalGroupList?${this.$xcUtils.serialize({
          season: this.queryForm.season,
          level: this.level,
          activityType: this.queryForm.activityType,
          isGroup: this.group
        })}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    submit1BFn (num) {
      this.$http.post('/national/endNationalGroupBScore', {
        activityType: this.queryForm.activityType,
        level: this.level,
        season: this.queryForm.season
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('本场比赛结束')
        }
      })
    },
    get1BRank () {
      this.$http.get('/national/queryNationalGroupList', {
        params: {
          season: this.queryForm.season,
          level: this.level,
          activityType: this.queryForm.activityType,
          round: 7, // 轮次写死 查排名增加的参数
          isGroup: this.group
        }
      }).then(res => {
        if (res.code === 200) {
          this.rankList = res.data
          this.setNextNum = Math.ceil(this.rankList.length * 0.6)
          this.showRank = true
        }
      })
    },
    setNextNumFn () {
      const nameStr = this.rankList.slice(0, this.setNextNum).map(item => item.userName).join(',')
      const txt = `选手：${nameStr}将晋级到C轮`
      this.$confirm(txt, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/national/endNationalGroupBScore', {
          activityType: this.queryForm.activityType,
          season: this.queryForm.season,
          level: this.level,
          topNum: this.setNextNum,
          isGroup: this.group
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('设置成功')
            this.showRank = false
          }
        })
      }).catch(() => {
      })
    },
    gradeFormatter (data) {
      return data.grade ? this.dict_grade.find(item => item.dictCode === data.grade).dictLabel : '--'
    },
    levelFormatter (data) {
      return data.level ? this.dict_group.find(item => item.dictCode === data.level).dictLabel : '--'
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    copy () {
      if (!this.queryForm.season) {
        return this.$message.warning('请选择赛季')
      }
      if (this.group === 1 && !this.level) {
        return this.$message.warning('请选择组别')
      }
      var input = document.createElement('input') // 创建input标签
      var loc = window.location.origin
      const query = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        level: this.level,
        group: 1,
        round: 'B'
      }
      input.value = `${loc}/#/pad/rank?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容
      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    }
  }
}
</script>
<style lang="less" scoped>
  .info{
    font-size: 14px;
    margin-bottom: 24px;
    // border-top: 1px solid #ebebeb;
    // padding-top: 20px;
  }
  .info-t{
    // width: 120px;
    margin-right: 12px;
    border-bottom: 2px solid #409EFF;
    margin-bottom: 12px;
    display: inline-block;
  }
  .correct /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    background-color: #67C23A;
    border-color: #67C23A;
    box-shadow: none;
  }
  .correct /deep/ .el-radio-button__inner:hover{
    // color: #fff;
  }
  .wrong /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    background-color: #F56C6C;
    border-color: #F56C6C;
    box-shadow: none;
  }
  .wrong /deep/ .el-radio-button__inner:hover{
    // color: #fff;
  }
  .score{
    font-size: 18px;
    color: #409EFF;
  }

  .radio-group{
    cursor: pointer;
    width: 110px;
    height: 32px;
    border: 1px solid #DCDFE6;
    color: #606266;
    font-weight: 500;
    display: flex;
    align-items: center;
    line-height: 32px;
    border-radius: 4px;
    .radio-correct{
      width: 55px;
      text-align: center;
      border-right: 1px solid #DCDFE6;
      &.active{
        background-color: #67C23A;
        color: #fff;
        border-radius: 4px 0 0 4px;
      }
    }
    .radio-wrong{
      width: 55px;
      text-align: center;
      &.active{
        background-color: #F56C6C;
        color: #fff;
        border-radius: 0 4px 4px 0;
      }
    }
  }
  .num {
    font-size: 18px;
    font-weight: bold;
    color: #409EFF;
  }
  .num1{
    color: #000;
  }
  .set-info{
    margin-bottom: 24px;
  }
  .refresh{
    color: #409EFF;
    cursor: pointer;
    margin-left: 12px;
  }
  .rank-score{
    color: red;
    font-size: 18px;
    font-weight: bold;
  }
  .rank-index{
    color: red;
    font-size: 18px;
    font-weight: bold;
    }
    /deep/ .el-tabs{
    margin-bottom: 20px;
    }
    /deep/ .el-tabs__content{
    padding: 0;
    }

    /deep/ .promote1 .el-input__inner {
      background: #67C23A;
      color: #fff;
    }
    /deep/ .promote0 .el-input__inner {
      background: #F56C6C;
      color: #fff;
    }
</style>
